// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 0px) and (max-width: 767px) {
  .featured_story_fact_check_container {
    display: none !important;
  }
  .featured_fact_check_image_component {
    width: 100% !important;
  }
  .featured_fact_check_mobile_view_title {
    font-size: 18px;
    font-weight: 700;
  }
  .featured_fact_check_mobile_view_sub_title {
    font-size: 13px;
  }
  .featured_fact_check_content_mobile_view {
    row-gap: 10px;
  }
  .featured_fact_check_thumbnail_overlay_content {
    height: 80px;
    width: 89% !important;
  }
  .featured_fact_check_image_component_title {
    font-size: 10px;
  }
  .featured_fact_check_view_count {
    font-size: 8px;
  }
  .featured_fact_check_thumbnail_overlay_name_and_date {
    font-size: 8px !important;
  }

  .fact_check_trending_stories_title_container {
    height: 70px;
    align-items: center;
  }
  .fact_check_trending_container {
    width: 90%;
    margin-left: 15px;
  }

  .fact_check_trending_stories_container {
    height: 300px;
  }

  .join_us_first_column {
    display: none !important;
  }
  .join_us_third_column {
    display: none !important;
  }
  .join_us_today_text {
    font-size: 10px;
    padding: 0px 10px 0px 10px;
  }
  .join_us_feature_text {
    font-size: 13px;
  }
  .join_us_button {
    font-size: 10px;
    height: 25px;
  }

  .category_tags_wrapper {
    display: none;
  }

  .fact_category_wise_card_container {
    width: 100%;
  }
  .featured_fact_check_title {
    width: 90%;
  }

  .fact_check_party_container {
    display: none;
  }
  .donation_main_container {
    border-radius: 0px !important;
    padding: 20px;
    gap: 20px;
  }
  .donation_third_row_container > h6,
  .amount_card_container {
    display: none !important;
  }
  .donation_third_row_container_ta > h6,
  .amount_card_container {
    display: none !important;
  }
  .social_media_logo_container {
    display: none;
  }
  .browse_categories_container {
    align-items: center;
    justify-content: center;
  }
  .category_wise_list_container {
    width: 95%;
  }
  .featured_story_image_skeleton {
    height: 220px !important;
  }
  .featured_story_content_skeleton {
    width: 90% !important;
    padding-top: 5%;
  }
  .donation_footer_container {
    flex-direction: row !important;
  }
  .donation_footer_container > text {
    font-size: 8px !important;
  }
  .donation_footer_container_ta {
    flex-direction: row !important;
  }
  .donation_footer_container_ta > text {
    font-size: 8px !important;
  }
  .donation_third_row_container > h5 {
    font-weight: 500 !important;
  }
  .donation_third_row_container_ta > h5 {
    font-weight: 500 !important;
    font-size: 14px;
  }
  .join_us_first_column {
    display: none !important;
  }
  .join_us_third_column {
    display: none !important;
  }

  .join_us_button {
    font-size: 10px;
    height: 25px;
  }
  .join_us_second_column {
    width: 100%;
    gap: 5px !important;
  }
  .single_fact_check_content_container {
    height: 100%;
    width: 100% !important;
  }
  .single_fact_check_whats_app_container {
    display: none !important;
  }
  .single_fact_check_report_donation_container {
    height: 100% !important;
    flex-direction: column !important;
  }
  .single_fact_check_report_donation_wrapper {
    height: 100%;
    width: 100% !important;
    display: flex;
    flex-direction: column !important;
  }
  .donation_secondary_banner {
    width: 100% !important;
  }
  .secondary_donation_container {
    padding: 15px !important;
    border-radius: 0px !important;
  }
  .secondary_donation_amount_container {
    height: 60px !important;
  }
  .secondary_donation_fight_against_container > h1 {
    font-size: 50px !important;
    font-weight: bold;
    padding-right: 10px;
  }

  .fact_trending_image {
    height: 180px;
  }
  .join_us_feature_text_ta {
    font-size: 10px;
  }
  .join_us_feature_text_container {
    padding-left: 10px;
    padding-right: 10px;
  }
  .fact_check_party_wise_mobile_container {
    margin-top: 18px;
  }
  .fact_category_wise_card_title_text {
    font-size: 11px;
  }
  .fact_category_wise_card_author_name_text {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_767/screen_767_fact_check.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,SAAS;EACX;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .featured_story_fact_check_container {\n    display: none !important;\n  }\n  .featured_fact_check_image_component {\n    width: 100% !important;\n  }\n  .featured_fact_check_mobile_view_title {\n    font-size: 18px;\n    font-weight: 700;\n  }\n  .featured_fact_check_mobile_view_sub_title {\n    font-size: 13px;\n  }\n  .featured_fact_check_content_mobile_view {\n    row-gap: 10px;\n  }\n  .featured_fact_check_thumbnail_overlay_content {\n    height: 80px;\n    width: 89% !important;\n  }\n  .featured_fact_check_image_component_title {\n    font-size: 10px;\n  }\n  .featured_fact_check_view_count {\n    font-size: 8px;\n  }\n  .featured_fact_check_thumbnail_overlay_name_and_date {\n    font-size: 8px !important;\n  }\n\n  .fact_check_trending_stories_title_container {\n    height: 70px;\n    align-items: center;\n  }\n  .fact_check_trending_container {\n    width: 90%;\n    margin-left: 15px;\n  }\n\n  .fact_check_trending_stories_container {\n    height: 300px;\n  }\n\n  .join_us_first_column {\n    display: none !important;\n  }\n  .join_us_third_column {\n    display: none !important;\n  }\n  .join_us_today_text {\n    font-size: 10px;\n    padding: 0px 10px 0px 10px;\n  }\n  .join_us_feature_text {\n    font-size: 13px;\n  }\n  .join_us_button {\n    font-size: 10px;\n    height: 25px;\n  }\n\n  .category_tags_wrapper {\n    display: none;\n  }\n\n  .fact_category_wise_card_container {\n    width: 100%;\n  }\n  .featured_fact_check_title {\n    width: 90%;\n  }\n\n  .fact_check_party_container {\n    display: none;\n  }\n  .donation_main_container {\n    border-radius: 0px !important;\n    padding: 20px;\n    gap: 20px;\n  }\n  .donation_third_row_container > h6,\n  .amount_card_container {\n    display: none !important;\n  }\n  .donation_third_row_container_ta > h6,\n  .amount_card_container {\n    display: none !important;\n  }\n  .social_media_logo_container {\n    display: none;\n  }\n  .browse_categories_container {\n    align-items: center;\n    justify-content: center;\n  }\n  .category_wise_list_container {\n    width: 95%;\n  }\n  .featured_story_image_skeleton {\n    height: 220px !important;\n  }\n  .featured_story_content_skeleton {\n    width: 90% !important;\n    padding-top: 5%;\n  }\n  .donation_footer_container {\n    flex-direction: row !important;\n  }\n  .donation_footer_container > text {\n    font-size: 8px !important;\n  }\n  .donation_footer_container_ta {\n    flex-direction: row !important;\n  }\n  .donation_footer_container_ta > text {\n    font-size: 8px !important;\n  }\n  .donation_third_row_container > h5 {\n    font-weight: 500 !important;\n  }\n  .donation_third_row_container_ta > h5 {\n    font-weight: 500 !important;\n    font-size: 14px;\n  }\n  .join_us_first_column {\n    display: none !important;\n  }\n  .join_us_third_column {\n    display: none !important;\n  }\n\n  .join_us_button {\n    font-size: 10px;\n    height: 25px;\n  }\n  .join_us_second_column {\n    width: 100%;\n    gap: 5px !important;\n  }\n  .single_fact_check_content_container {\n    height: 100%;\n    width: 100% !important;\n  }\n  .single_fact_check_whats_app_container {\n    display: none !important;\n  }\n  .single_fact_check_report_donation_container {\n    height: 100% !important;\n    flex-direction: column !important;\n  }\n  .single_fact_check_report_donation_wrapper {\n    height: 100%;\n    width: 100% !important;\n    display: flex;\n    flex-direction: column !important;\n  }\n  .donation_secondary_banner {\n    width: 100% !important;\n  }\n  .secondary_donation_container {\n    padding: 15px !important;\n    border-radius: 0px !important;\n  }\n  .secondary_donation_amount_container {\n    height: 60px !important;\n  }\n  .secondary_donation_fight_against_container > h1 {\n    font-size: 50px !important;\n    font-weight: bold;\n    padding-right: 10px;\n  }\n\n  .fact_trending_image {\n    height: 180px;\n  }\n  .join_us_feature_text_ta {\n    font-size: 10px;\n  }\n  .join_us_feature_text_container {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .fact_check_party_wise_mobile_container {\n    margin-top: 18px;\n  }\n  .fact_category_wise_card_title_text {\n    font-size: 11px;\n  }\n  .fact_category_wise_card_author_name_text {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
